import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { Addresses as AddressesUnified } from './Addresses'
import { AddressesLegacy } from './AddressesLegacy'
import type { AddressesProps } from './useAddressesModel'

export const Addresses: React.FC<AddressesProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <AddressesUnified {...props} />
  ) : (
    <AddressesLegacy {...props} />
  )
}
